export default __webpack_public_path__ + "static/media/agent.0da48e08.svg";